import { useEffect } from "react";

function setMetaTag(attrName, key, value) {
  let element = document.head.querySelector(`meta[${attrName}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attrName, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
}

function setLinkTag(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

export default function PageMeta({
  title,
  description,
  keywords,
  url,
  image,
  twitterCard = "summary_large_image",
  noindex = false,
}) {
  useEffect(() => {
    setMetaTag("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    if (title) {
      document.title = title;
      setMetaTag("property", "og:title", title);
      setMetaTag("name", "twitter:title", title);
    }

    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
      setMetaTag("name", "twitter:description", description);
    }

    if (keywords) {
      setMetaTag("name", "keywords", keywords);
    }

    if (url) setMetaTag("property", "og:url", url);
    if (url && !noindex) {
      setLinkTag("canonical", url);
    } else {
      // Don't leave the previous page's canonical behind
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }

    if (image) {
      setMetaTag("property", "og:image", image);
      setMetaTag("name", "twitter:image", image);
    }

    if (twitterCard) {
      setMetaTag("name", "twitter:card", twitterCard);
    }
  }, [title, description, keywords, url, image, twitterCard, noindex]);

  return null;
}
